import React from 'react';

const keys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'];

function DialPad({ value, onChange, maxLength }) {
  const handleKey = (key) => {
    if (key === '⌫') {
      onChange(value.slice(0, -1));
      return;
    }
    if (maxLength && value.length >= maxLength) return;
    onChange(value + key);
  };

  return (
    <div style={wrapperStyle}>
      <div style={displayStyle}>
        {value ? (
          <span style={{ letterSpacing: '4px', fontSize: '22px' }}>{value}</span>
        ) : (
          <span style={{ color: '#bbb', fontSize: '16px' }}>Tap to enter</span>
        )}
      </div>

      <div style={gridStyle}>
        {keys.map((k) => (
          <button key={k} style={keyStyle} onClick={() => handleKey(k)}>
            {k}
          </button>
        ))}
        <button style={{ ...keyStyle, background: 'transparent', border: 'none', color: '#888', fontSize: '20px' }} onClick={() => {}}>
          {/* empty slot */}
        </button>
        <button style={{ ...keyStyle, background: '#f0f4ff', color: '#1a56db' }} onClick={() => handleKey('⌫')}>
          ⌫
        </button>
      </div>
    </div>
  );
}

const wrapperStyle = {
  margin: '0 auto 16px',
  maxWidth: '320px',
};

const displayStyle = {
  background: '#f8faff',
  border: '2px solid #e8f0fe',
  borderRadius: '12px',
  padding: '14px 20px',
  textAlign: 'center',
  marginBottom: '16px',
  minHeight: '54px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const gridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gap: '10px',
};

const keyStyle = {
  background: '#fff',
  border: '2px solid #e8f0fe',
  borderRadius: '50%',
  width: '72px',
  height: '72px',
  fontSize: '22px',
  fontWeight: '600',
  cursor: 'pointer',
  margin: '0 auto',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#1a1a2e',
  boxShadow: '0 2px 8px rgba(26,86,219,0.07)',
  transition: 'background 0.1s',
};

export default DialPad;
